import React from 'react'

const Nosotros = () => {
    return (
        <div>
            {/* <!-- Latest offers Start --> */}
            <div className="latest-offers categories content-area-7">
                <div className="container">
                    {/* <!-- Main title --> */}
                    <div className="main-title text-center">
                        <h1>Acerca de nosotros</h1>
                        <p>Somos un negocio inspirado en Visión, impulsado por Misión y respaldado por Valores. Hemos puesto nuestra Visión aquí para que la veas.</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="service-info-2">
                                <div className="detail">
                                    <h5>Nuestra Mision</h5>
                                    <p>Proporcionar servicios de importacion, exportacion y logística aduanera</p>
                                    <p>Brindar soluciones innovadoras atravez de la eficiencia, seguridad y calidad, manteniendo crecimiento continuo y apoyando la competitividad de nuestros clientes.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="service-info-2">
                                <div className="detail">
                                    <h5>Nuestra Visión</h5>
                                    <p>Consolidar nuestra empresa como una corporación competitiva a nivel internacional en los rubros de aduanas y logística. Lograr el reconocimiento de nuestros clientes como organización ágil y confiable.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="service-info-2">
                                <div className="detail">
                                    <h5>Nuestros Valores</h5>
                                    <p>Responsabilidad social</p>
                                    <p>Transparencia y honestidad</p>
                                    <p>Máxima calidad y constancia</p>
                                    <p>Aprendizaje y adaptabilidad</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Latest offers end --> */}
        </div>
    )
}

export default Nosotros



// WEBPACK FOOTER //
// ./src/components/Nosotros.jsx